'use strict';

var _jsx = require('@babel/runtime/helpers/jsx');
require('core-js/modules/es.array.iterator.js');
require('core-js/modules/es.promise.js');
require('core-js/modules/web.dom-collections.iterator.js');
var react = require('react');
require('prop-types');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var button = require('@andes/button');
var constants = require('@recommendations-fe/commons/constants');
var jsxRuntime = require('react/jsx-runtime');
var MoneyAmount = require('@andes/money-amount');
var frontendImage = require('frontend-image');
var badge = require('@andes/badge');
var classNames = require('classnames');
var modal = require('@andes/modal');
var progressIndicatorCircular = require('@andes/progress-indicator-circular');
var message = require('@andes/message');
var commons = require('@recommendations-fe/commons');
const namespaceCoupon = 'ui-recommendations-coupon';
const namespaceRecosUi = 'ui-recommendations';
const CouponWrapper = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespaceCoupon, "-card")
  }, void 0, children);
};
var CouponWrapper$1 = CouponWrapper;
const sendMelidataTracks = data => {
  if (typeof melidata === 'function' && data) {
    // eslint-disable-next-line no-undef
    melidata('cleanAndSend', (data === null || data === void 0 ? void 0 : data.type) || 'event', {
      path: data === null || data === void 0 ? void 0 : data.path,
      event_data: data === null || data === void 0 ? void 0 : data.event_data
    });
  }
};
const CuponBottomRow = _ref => {
  let {
    activate,
    setActiveCoupon,
    data,
    IconFactory,
    appliedCoupon,
    url
  } = _ref;
  const {
    button_text_primary: buttonTextPrimary,
    expiration_info: expirationInfo,
    track_event: trackEvent
  } = data;
  const {
    expiration_text: expirationText
  } = _objectSpread({}, expirationInfo);
  const handlerActivateCoupon = async () => {
    if (appliedCoupon) {
      if (trackEvent !== null && trackEvent !== void 0 && trackEvent.applied_coupon) sendMelidataTracks(trackEvent.applied_coupon);
      return;
    }
    if (data) {
      if (trackEvent) sendMelidataTracks(trackEvent.melidata_event);
      setActiveCoupon({
        isLoading: true
      });
      const response = await activate();
      if (response.success && response !== null && response !== void 0 && response.modal) {
        setActiveCoupon({
          data: response.modal,
          isLoading: false,
          show: true,
          success: true
        });
        if (response !== null && response !== void 0 && response.track_event) sendMelidataTracks(response.track_event.melidata_event);
      } else {
        setActiveCoupon({
          data,
          isLoading: false,
          show: false,
          success: false
        });
      }
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: "bottom-row expiration-date"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "expiration"
  }, void 0, expirationInfo && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [(expirationInfo === null || expirationInfo === void 0 ? void 0 : expirationInfo.type) && IconFactory(expirationInfo.type !== 'stock-out' ? constants.RECOMMENDATIONS_CLOCK_ICON : constants.RECOMMENDATIONS_FIRE_ICON, "expiration-icon-".concat(expirationInfo.type)), /*#__PURE__*/_jsx("span", {
      className: "expiration-text ".concat(expirationInfo.type)
    }, void 0, expirationText === null || expirationText === void 0 ? void 0 : expirationText.text)]
  })), /*#__PURE__*/_jsx(button.Button, {
    size: "small",
    onClick: handlerActivateCoupon,
    href: url,
    hierarchy: appliedCoupon ? 'quiet' : 'loud'
  }, void 0, /*#__PURE__*/_jsx(button.ButtonText, {}, void 0, appliedCoupon ? buttonTextPrimary.text_applied : buttonTextPrimary === null || buttonTextPrimary === void 0 ? void 0 : buttonTextPrimary.text)));
};
var CouponBottomRow = CuponBottomRow;
var _Pill;
const CouponBadge = _ref => {
  let {
    iconUrl,
    IconFactory,
    appliedCoupon,
    icon
  } = _ref;
  const containerClass = classNames("".concat(namespaceCoupon, " badge"), {
    'coupon-badge-badge--applied': appliedCoupon
  });
  return /*#__PURE__*/_jsx("div", {
    className: containerClass
  }, void 0, appliedCoupon && (_Pill || (_Pill = /*#__PURE__*/_jsx(badge.Pill, {
    color: "green",
    contentType: "icon",
    size: "small"
  }))), icon ? IconFactory("recommendations-".concat(icon, "_icon"), "".concat(namespaceCoupon, "-icon")) : /*#__PURE__*/_jsx(frontendImage.Image, {
    src: iconUrl,
    className: "".concat(namespaceCoupon, "-icon"),
    lazyload: "off",
    width: 40,
    height: 40
  }));
};
var CouponBadge$1 = CouponBadge;
const CouponTopRow = _ref => {
  let {
    data,
    IconFactory,
    openModal,
    appliedCoupon
  } = _ref;
  const {
    title,
    subtitle,
    min_purchase: minPurchase,
    max_amount: maxAmount,
    icon,
    icon_url: iconUrl
  } = data;
  const {
    currency_id: currencyId,
    purchase_text: minPurchaseText,
    value: minAmountValue
  } = _objectSpread({}, minPurchase);
  const {
    purchase_text: maxPurchaseText,
    value: maxAmountValue
  } = _objectSpread({}, maxAmount);
  return /*#__PURE__*/_jsx("div", {
    className: "top-row"
  }, void 0, (icon || iconUrl) && /*#__PURE__*/_jsx(CouponBadge$1, {
    icon: icon,
    iconUrl: iconUrl,
    IconFactory: IconFactory,
    appliedCoupon: appliedCoupon
  }), /*#__PURE__*/_jsx("div", {
    className: "info-section"
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: "title ".concat(namespaceRecosUi, "-font-size--").concat(title.font_size),
    style: {
      color: title === null || title === void 0 ? void 0 : title.color
    }
  }, void 0, title === null || title === void 0 ? void 0 : title.text), /*#__PURE__*/_jsx("div", {
    className: "subtitles"
  }, void 0, (subtitle === null || subtitle === void 0 ? void 0 : subtitle.text) && /*#__PURE__*/_jsx("span", {
    className: "subtitle"
  }, void 0, subtitle.text), minPurchase && /*#__PURE__*/_jsx("span", {
    className: "subtitle"
  }, void 0, /*#__PURE__*/_jsx("section", {
    className: "interpolated-label__container"
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: "text-label"
  }, void 0, minPurchaseText.text), minAmountValue && /*#__PURE__*/_jsx(MoneyAmount, {
    centsType: "dot",
    size: 12,
    currencyId: currencyId,
    value: {
      fraction: minAmountValue.toString()
    }
  }))), maxAmount && /*#__PURE__*/_jsx("span", {
    className: "subtitle"
  }, void 0, /*#__PURE__*/_jsx("section", {
    className: "interpolated-label__container"
  }, void 0, (maxPurchaseText === null || maxPurchaseText === void 0 ? void 0 : maxPurchaseText.text) && /*#__PURE__*/_jsx("span", {
    className: "text-label"
  }, void 0, maxPurchaseText.text), maxAmountValue && /*#__PURE__*/_jsx(MoneyAmount, {
    centsType: "dot",
    size: 12,
    currencyId: currencyId,
    value: {
      fraction: maxAmountValue.toString()
    }
  }), /*#__PURE__*/_jsx("button", {
    className: "info-icon-button",
    onClick: openModal
  }, void 0, IconFactory(constants.RECOMMENDATIONS_INFO_ICON, 'info-icon')))))));
};
var CouponTopRow$1 = CouponTopRow;
const CouponTitle = _ref => {
  let {
    title,
    size
  } = _ref;
  return /*#__PURE__*/_jsx("h2", {
    className: "".concat(namespaceCoupon, " coupon-card-title ").concat(namespaceRecosUi, "-font-size--").concat(size)
  }, void 0, title);
};
var CouponTitle$1 = CouponTitle;
const CouponModal = _ref => {
  let {
    isOpen,
    closeModal,
    data,
    isDesktop
  } = _ref;
  const {
    title,
    content
  } = data;
  return /*#__PURE__*/_jsx(modal.Modal, {
    open: isOpen,
    type: isDesktop ? 'card' : 'full',
    className: "modal",
    url: "#show-modal",
    onClose: closeModal,
    title: title
  }, void 0, /*#__PURE__*/_jsx("p", {}, void 0, content));
};
var CouponModal$1 = CouponModal;
var _div, _ProgressIndicatorCir;
const CouponLoading = () => /*#__PURE__*/_jsx("div", {
  className: "".concat(namespaceCoupon, "-container-loading")
}, void 0, _div || (_div = /*#__PURE__*/_jsx("div", {
  className: "title-loading"
})), /*#__PURE__*/_jsx("div", {
  className: "".concat(namespaceCoupon, "-loading")
}, void 0, _ProgressIndicatorCir || (_ProgressIndicatorCir = /*#__PURE__*/_jsx(progressIndicatorCircular.ProgressIndicatorCircular, {
  size: "medium",
  color: "blue",
  show: true
}))));
var CouponLoading$1 = CouponLoading;
const CouponMessage = _ref => {
  let {
    info
  } = _ref;
  const {
    data
  } = info;
  return /*#__PURE__*/_jsx(message.Message, {
    className: "message",
    color: "green",
    hierarchy: "quiet",
    closable: false
  }, void 0, /*#__PURE__*/_jsx("span", {}, void 0, commons.interpolator(data.header.text, data.header.values)));
};
var CouponMessage$1 = CouponMessage;
const SPACING = {
  PADDING_TOP: '10px',
  PADDING_BOTTOM: '10px',
  PADDING_LEFT: '20px',
  PADDING_RIGHT: '20px'
};
var _CouponLoading;
const Coupon = _ref => {
  var _couponState$data$url, _couponState$data;
  let {
    data,
    activate,
    campaign,
    iconFactory,
    isCouponExperience = false,
    isDesktop = false,
    onNotifyLoading = () => {}
  } = _ref;
  if (!(data !== null && data !== void 0 && data.modal) && !(data !== null && data !== void 0 && data.id_campaign)) return null;
  const [couponState, setCouponState] = react.useState({
    data: null,
    show: false,
    isLoading: false,
    success: true
  });
  const {
    title_page: titlePage,
    background_color: bc,
    modal,
    track_view: trackView,
    margin_vertical: marginVertical,
    margin_horizontal: marginHorizontal,
    isApplied = false,
    url
  } = data;
  const [modalState, setModalState] = react.useState({
    data: {
      title: titlePage === null || titlePage === void 0 ? void 0 : titlePage.text
    },
    isOpen: false
  });
  react.useEffect(() => {
    if (trackView) {
      sendMelidataTracks(trackView === null || trackView === void 0 ? void 0 : trackView.melidata_event);
    }
    setCouponState({
      data: modal || data,
      show: !!modal,
      success: !!modal
    });
  }, [modal, trackView, data]);
  react.useEffect(() => {
    onNotifyLoading(couponState.isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponState.isLoading]);
  const openModal = async () => {
    const response = await campaign();
    if (response !== null && response !== void 0 && response.success) {
      var _data$title, _response$terms;
      setModalState({
        data: {
          title: data === null || data === void 0 || (_data$title = data.title) === null || _data$title === void 0 ? void 0 : _data$title.text,
          content: response === null || response === void 0 || (_response$terms = response.terms) === null || _response$terms === void 0 ? void 0 : _response$terms.content
        },
        isOpen: true
      });
    }
  };
  const closeModal = () => {
    var _data$title2;
    setModalState({
      data: {
        title: data === null || data === void 0 || (_data$title2 = data.title) === null || _data$title2 === void 0 ? void 0 : _data$title2.text
      },
      isOpen: false
    });
  };
  const shouldMessageShow = !couponState.isLoading && couponState.show && couponState.success && couponState.data;
  const shouldCouponShow = isCouponExperience || !couponState.show && !couponState.isLoading && couponState.data;
  const appliedCoupon = isCouponExperience && (isApplied || url || shouldMessageShow);
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespaceCoupon, "-container"),
    style: {
      backgroundColor: bc,
      paddingTop: marginVertical || SPACING.PADDING_TOP,
      paddingBottom: marginVertical || SPACING.PADDING_BOTTOM,
      paddingLeft: marginHorizontal || SPACING.PADDING_LEFT,
      paddingRight: marginHorizontal || SPACING.PADDING_RIGHT
    }
  }, void 0, shouldCouponShow && /*#__PURE__*/_jsx("div", {}, void 0, (titlePage === null || titlePage === void 0 ? void 0 : titlePage.text) && /*#__PURE__*/_jsx(CouponTitle$1, {
    title: titlePage.text,
    size: titlePage.font_size
  }), /*#__PURE__*/_jsx(CouponWrapper$1, {}, void 0, /*#__PURE__*/_jsx(CouponTopRow$1, {
    openModal: openModal,
    data: data,
    IconFactory: iconFactory,
    appliedCoupon: appliedCoupon
  }), /*#__PURE__*/_jsx(CouponBottomRow, {
    activate: activate,
    setActiveCoupon: setCouponState,
    data: data,
    IconFactory: iconFactory,
    appliedCoupon: appliedCoupon,
    url: (_couponState$data$url = couponState === null || couponState === void 0 || (_couponState$data = couponState.data) === null || _couponState$data === void 0 ? void 0 : _couponState$data.url) !== null && _couponState$data$url !== void 0 ? _couponState$data$url : url
  }))), !isCouponExperience && shouldMessageShow && /*#__PURE__*/_jsx(CouponMessage$1, {
    info: couponState
  }), !isCouponExperience && couponState.isLoading && !couponState.show && (_CouponLoading || (_CouponLoading = /*#__PURE__*/_jsx(CouponLoading$1, {}))), /*#__PURE__*/_jsx(CouponModal$1, {
    isOpen: modalState.isOpen,
    isLoading: modalState.isLoading,
    closeModal: closeModal,
    data: modalState.data,
    isDesktop: isDesktop
  }));
};
var Coupon$1 = Coupon;
module.exports = Coupon$1;
